import { parse } from 'date-fns';
import { format, toZonedTime } from 'date-fns-tz';

export const clearPhoneNumber = (phone: string): string => {
  return phone.replace(/[^0-9 ()]/g, '');
};

export const flattenObject = (obj: object): Record<string, unknown> => {
  const source = obj as Record<string, unknown>;
  const flattenKeys: Record<string, unknown> = {};
  for (const key in source) {
    if (!Object.hasOwn(source, key)) continue;
    const value = source[key];
    if (value !== null && typeof value === 'object') {
      const nested = flattenObject(value);
      for (const nestedKey in nested) {
        if (!Object.hasOwn(nested, nestedKey)) continue;
        flattenKeys[key + '.' + nestedKey] = nested[nestedKey];
      }
    } else {
      flattenKeys[key] = value;
    }
  }
  return flattenKeys;
};

export const compareVersions = (a: string, b: string): number => {
  let i, diff;
  const regExStrip0 = /(\.0+)+$/;
  const segmentsA = a.replace(regExStrip0, '').split('.');
  const segmentsB = b.replace(regExStrip0, '').split('.');
  const l = Math.min(segmentsA.length, segmentsB.length);

  for (i = 0; i < l; i++) {
    diff = parseInt(segmentsA[i], 10) - parseInt(segmentsB[i], 10);
    if (diff) {
      return diff;
    }
  }
  return segmentsA.length - segmentsB.length;
};

export const generateDayTimesAmPm = (step: number): string[] => {
  const date = new Date(1970, 0, 1);
  const times: string[] = [];
  while (date.getDate() === 1) {
    times.push(format(date, 'hh:mm aa'));
    date.setMinutes(date.getMinutes() + step);
  }
  return times;
};

export const convertTimeStringTo24Hours = (timeString: string): string => {
  const dateFromTime = parse(timeString, 'hh:mm aa', new Date());
  return format(dateFromTime, 'HH:mm:ss');
};

// format date to timezone format with the pattern
export const formatDateStringWithTZ = (
  date: string,
  timezone: string,
  pattern: string,
): string => {
  return format(toZonedTime(new Date(date), timezone), pattern);
};

export const formatDateStringWithTZtoISO = (
  date: string,
  timezone: string,
): string => {
  const formatted = toZonedTime(new Date(date), timezone);
  return format(formatted, "yyyy-MM-dd'T'HH:mm:ssXXX", { timeZone: timezone });
};

export const determineAmPmBy24Hour = (hour: number): string => {
  return hour / 12 >= 1 ? 'PM' : 'AM';
};

export const convert24HourToAmPmValue = (hour: number): number => {
  return determineAmPmBy24Hour(hour) === 'PM'
    ? hour !== 12
      ? hour - 12
      : 12
    : hour === 0
      ? 12
      : hour;
};

export const convertAmPmTo24HourValue = (
  hour: number,
  chosenHours: number,
): number => {
  return determineAmPmBy24Hour(chosenHours) === 'PM'
    ? hour === 12
      ? hour
      : hour + 12
    : hour === 12
      ? 0
      : hour;
};
